import $api from '@/apiProvider'
import $C from "@/consts/index";
import {searchTime, SEARCH_TIME} from "@/filters/time";
import moment from "moment";
import Import from "@/components/common/Import"; // 导入
import CreateInvoice from "./CreateInvoice.vue";
import InvoiceDetail from '@/views/invoice/InvoiceDetail.vue'
import Detail from "@/views/invoice/Detail";
import ChooseInvoice from '@/components/modal/ChooseInvoice'
import SearchFilters from '@/components/common/SearchFilters'
import {
  viewOrderDetail,
  invoiceFooter,
  getBlob,
  saveBlob,
  assign,
  showLoading,
  hideLoading,
  isEmpty
} from '@/utils/util'
import getAuthOrization from "@/mixin/getAuthOrization";
import openProcedureDetail from "@/mixin/viewOrderDetail";

const empties = [undefined, '', null, 'null', {}, []]

export default {
  mixins: [getAuthOrization, openProcedureDetail],
  name: 'PaymentList',
  components: {
    Import,
    CreateInvoice,
    InvoiceDetail,
    ChooseInvoice,
    SearchFilters,
    Detail
  },
  props: {
    cate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      searchLoading: false,
      searchVisible: false,
      open: false,
      contractBusTypeOption: [],
      invoiceTypeOption: $C.invoiceType.options,
      fileOptions: $C.HAS_FILE_TYPE.options,
      timeOptions: SEARCH_TIME.options,
      searchInvoiceCompName: [],
      searchInvoiceTitle: [],
      invoiceCompNameOptions: [],
      invoiceTitleOptions: [],
      searchSalesMan: [],
      salesManOptions: [],
      searchCreateUser: [],
      createUserOptions: [],
      searchClientManager: [],
      clientManagerOptions: [],
      isImport: false,
      templateVisible: false,
      isShowCreateInvoice: false,//添加弹窗
      isShowCreateInvoiceImport: false,//导入发票
      isShowInvoiceDetail: false,//详情弹窗
      isShowChooseInvoice: false,//选择发票弹窗
      isShowImportInvoice: false,//导入发票
      isShowDetail: false,
      invoiceDetailData: {},
      tableData: [],
      countRtnVo: {},
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        orderBy: 2,
        isDesc: 1,
      },
      searchFormData: {
        invoiceNum: null,
        invoiceTitle: null,
        invoiceCompName: null,
        goodsName: null,
        carShipNum: null,
        chainNum: null,
        orderNum: null,
        contractBusType: null,
        invoiceType: null,
        addTime: null,
        createTime: null,
        salesMan: null,
        createUser: null,
        hasFile: null,
        flowNum: null,
        clientManager: null,
        deductTime: null
      },
      searchFormItems: [
        {
          title: "搜索",
          span: 24,
          titleAlign: "left",
          titleWidth: 200,
        },
        {
          field: "invoiceNum",
          title: "发票号",
          span: 12,
          titleAlign: "left",
          itemRender: {
            name: "$input",
            props: {placeholder: "输入发票号"},
          },
        },
        {
          field: "flowNum",
          title: "流程编号",
          span: 12,
          titleAlign: "left",
          itemRender: {
            name: "$input",
            props: {placeholder: "输入流程编号"},
          },
        },
        {
          field: "contractBusType",
          title: "业务类型",
          titleAlign: "left",
          span: 12,
          itemRender: {
            name: "$select",
            props: {placeholder: "选择业务类型", transfer: false},
            options: $C.CONTRACTBUS_TYPE.options,
          },
        },
        {
          field: "invoiceType",
          title: "发票类型",
          titleAlign: "left",
          span: 12,
          itemRender: {
            name: "$select",
            props: {placeholder: "选择发票类型", transfer: false},
            options: $C.invoiceType.options,
          },
        },
        {
          field: "invoiceCompName",
          title: "开票单位",
          titleAlign: "left",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "输入开票单位"}},
        },
        {
          field: "invoiceTitle",
          title: "发票抬头",
          titleAlign: "left",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "输入发票抬头"}},
        },
        {
          field: "goodsName",
          title: "应税商品名",
          titleAlign: "left",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "输入应税商品名"}},
        },
        {
          field: "carShipNum",
          title: "车船号",
          titleAlign: "left",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "输入车船号"}},
        },
        {
          field: "hasFile",
          title: "附件筛查",
          titleAlign: "left",
          span: 12,
          itemRender: {
            name: "$select",
            props: {placeholder: "请选择是否包含附件", transfer: false},
            options: $C.HAS_FILE_TYPE.options,
          },
        },
        {
          field: "chainNum",
          title: "总订单编号",
          titleAlign: "left",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "输入总订单编号"}},
        },
        {
          field: "orderNum",
          title: "子订单编号",
          titleAlign: "left",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "输入子订单编号"}},
        },

        {
          field: "addTime",
          title: "开票日期",
          titleAlign: "left",
          span: 12,
          itemRender: {
            name: "$select",
            props: {placeholder: "请选择时间", transfer: false},
            options: SEARCH_TIME.options,
          }
        },
        {
          field: "createTime",
          title: "按创建时间",
          titleAlign: "left",
          span: 12,
          itemRender: {
            name: "$select",
            props: {placeholder: "请选择时间", transfer: false},
            options: SEARCH_TIME.options,
          }
        },
        {
          field: "salesMan",
          title: "业务员",
          titleAlign: "left",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "输入业务员"}},
        },
        {
          field: "createUser",
          title: "创建人",
          titleAlign: "left",
          span: 12,
          itemRender: {name: "$input", props: {placeholder: "输入创建人"}},
        },
        {
          align: "right",
          span: 24,
          titleAlign: "left",
          itemRender: {
            name: "$buttons",
            children: [
              {props: {type: "submit", content: "提交", status: "primary"}},
              {props: {type: "reset", content: "重置"}},
            ],
          },
        },
      ],
    };
  },
  watch: {
    "searchFormData.addTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("addTime");
      },
    },
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
    "searchFormData.deductTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("deductTime");
      },
    },
  },
  mounted() {
    this.$bus.$on("销项发票", () => {
      this.reset()
      this.getSearchListKey();
    });
    this.$bus.$on("进项发票", () => {
      this.reset()
      this.getSearchListKey();
    });
    this.getList('', 'invoiceCompNameOptions', 'invoice', 'queryInvoiceKeyword', 1);
    this.getList('', 'invoiceTitleOptions', 'invoice', 'queryInvoiceKeyword', 2);
    this.getList('', 'clientManagerOptions', 'invoice', 'queryInvoiceKeyword', 3);
    this.getList('', 'salesManOptions', 'invoice', 'queryInvoiceKeyword', 4);
    this.getList('', 'createUserOptions', 'invoice', 'queryInvoiceKeyword', 5);
    this.getDicContractBusType();
  },
  methods: {
    reset() {
      this.searchFormData = {
        invoiceNum: null,
        invoiceTitle: null,
        invoiceCompName: null,
        goodsName: null,
        carShipNum: null,
        chainNum: null,
        orderNum: null,
        contractBusType: null,
        invoiceType: null,
        addTime: null,
        createTime: null,
        salesMan: null,
        createUser: null,
        hasFile: null,
        flowNum: null,
        clientManager: null
      }
      this.searchInvoiceCompName = [];
      this.searchInvoiceTitle = [];
      this.searchClientManager = [];
      this.searchSalesMan = [];
      this.searchCreateUser = [];
      this.getList('', 'invoiceCompNameOptions', 'invoice', 'queryInvoiceKeyword', 1);
      this.getList('', 'invoiceTitleOptions', 'invoice', 'queryInvoiceKeyword', 2);
      this.getList('', 'clientManagerOptions', 'invoice', 'queryInvoiceKeyword', 3);
      this.getList('', 'salesManOptions', 'invoice', 'queryInvoiceKeyword', 4);
      this.getList('', 'createUserOptions', 'invoice', 'queryInvoiceKeyword', 5);
    },
    getDicContractBusType() {
      this.contractBusTypeOption = [];
      $api.other.getContractBusTypeModel
        .GET({
          params: {
            page: 1,
            rows: 100,
          },
        })
        .then((res) => {
          res.data.forEach((item) => {
            var obj = {
              label: item.dictText,
              value: parseInt(item.note),
            };
            this.contractBusTypeOption.push(obj);
          });
        });
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
        moduleType: this.cate === 'Sales' ? 2 : 1
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        this[options] = res.data;
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    init() {
      this.getListData()
    },
    getSearchListKey() {
      let obj = this.searchFormData;
      let searchParams = {};
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null && key !== "createTime") {
          searchParams[key] = obj[key];
        }
        if (obj["addTime"] && obj["addTime"].length > 0) {
          searchParams.addTimeBegin = moment(obj.addTime[0]).valueOf(); // 开始时间
          searchParams.addTimeEnd = moment(obj.addTime[1]).valueOf() + 86399999; // 结束时间
          delete searchParams.addTime
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          searchParams.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          searchParams.createTimeEnd = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
          delete searchParams.createTime
        }
        if (obj["deductTime"] && obj["deductTime"].length > 0) {
          searchParams.deductTimeBegin = moment(obj.deductTime[0]).valueOf(); // 开始时间
          searchParams.deductTimeEnd = moment(obj.deductTime[1]).valueOf() + 86399999; // 结束时间
          delete searchParams.createTime
        }
      });
      if (this.searchInvoiceCompName.length > 0) {
        searchParams.invoiceCompName = this.searchInvoiceCompName[0];
      }
      if (this.searchInvoiceTitle.length > 0) {
        searchParams.invoiceTitle = this.searchInvoiceTitle[0];
      }
      if (this.searchClientManager.length > 0) {
        searchParams.clientManager = this.searchClientManager[0];
      }
      if (this.searchSalesMan.length > 0) {
        searchParams.salesMan = this.searchSalesMan[0];
      }
      if (this.searchCreateUser.length > 0) {
        searchParams.createUser = this.searchCreateUser[0];
      }
      this.searchParams = searchParams
      this.page.currentPage = 1
      this.getListData();
      this.searchVisible = false;
    },
    async download() {
      if (isEmpty(this.tableData)) {
        this.$XModal.message("暂无数据")
        return
      }
      let params = assign(this.searchParams);
      params.type = this.cate === "Sales" ? 2 : 1;
      params.orderBy = this.page.orderBy
      params.isDesc = this.page.isDesc
      showLoading()
      let res = getBlob("/api/order/invoice/exportInvoiceList", params);
      hideLoading()
      let fileName = this.cate === "Sales" ? "导出销项发票.xls" : "导出进项发票.xls";
      await saveBlob(fileName, res.data)
    },
    async getListData() {
      this.loading = true;
      let params = {
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: this.page.orderBy,
        isDesc: this.page.isDesc
      }
      if (!empties.includes(this.searchParams)) {
        params = Object.assign(params, this.searchParams)
      }
      let resData;
      if (this.cate == 'Sales') {
        resData = await $api.invoice.request('queryInvoiceSellerList', params)
      } else {
        resData = await $api.invoice.request('queryInvoiceBuyerList', params)
      }
      if (resData.status == 1) {
        let pageData = resData.data
        this.tableData = pageData.rows.map(item => {
          let orderNumObj = {
            ordersNum: item.ordersSellerNum ? item.ordersSellerNum : (item.ordersBuyerNum ? item.ordersBuyerNum : null),
            ordersId: item.ordersSellerId ? item.ordersSellerId : (item.ordersBuyerId ? item.ordersBuyerId : null),
          }
          return Object.assign(item, orderNumObj)
        })
        //分页
        this.page.currentPage = pageData.pageNum
        this.page.pageSize = pageData.pageSize
        this.page.total = pageData.total
        //统计数据
        this.countRtnVo = pageData.countRtnVo
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: resData.message ? resData.message : '接口异常',
          status: "error",
        });
      }
    },
    pageChange(page) {
      this.page.currentPage = page.currentPage
      this.page.pageSize = page.pageSize
      this.getListData()
    },
    footerCellClassName({$rowIndex, column, columnIndex}) {
      return 'footer-cell'
    },
    footerMethod({columns, data}) {
      return invoiceFooter({columns, data, countRtnVo: this.countRtnVo})
    },
    sortChangeEvent(sort) {
      console.log(sort)
      if (sort.order == null) {
        this.page.isDesc = 1
        this.page.orderBy = 2
      } else {
        this.page.isDesc = sort.order === 'desc' ? 1 : 0
        if (sort.field === 'addTime') {
          this.page.orderBy = 3;
        }
        if (sort.field === 'deductTime') {
          this.page.orderBy = 8;
        }
      }
      this.getListData()
    },
    async cellClickEvent(e) {
      let field = e.column.property
      let row = e.row
      // console.log(row);
      // debugger
      // let orderFields = ['chainNum', 'ordersBuyerNum', 'ordersSellerNum']
      if (field == 'invoiceNum') {
        if (this.cate == 'Sales'){
          if (!this.isHavePermission('invoiceSeller:detail')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
          }
        }else if (this.cate == "Income")
          if (!this.isHavePermission('invoiceBuyer:detail')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
          }
        this.viewDetail(e.row)
      } else if (field == 'chainNum') {
        this.openOrderDetail(row.chainId, 0)
      } else if (field == 'ordersNum') {
        let firWord = row.ordersNum.substr(0, 1);
        if (firWord == 'G') {
          this.openOrderDetail(row.ordersId, 1)
          // orderDetail(this, 1, row.ordersId)
        } else if (firWord == 'S') {
          this.openOrderDetail(row.ordersId, 2)
          // orderDetail(this, 2, row.ordersId)
        } else {
          this.openOrderDetail(row.ordersId, 3)
        }
        // this.openOrderDetail(row.ordersId ,1)
      }
      // if (orderFields.includes(field)) {
      //   viewOrderDetail(this, row, field)
      // } else if (field == 'invoiceNum') {
      //   this.viewDetail(e.row)
      // }
    },
    viewDetail(row) {
      this.isShowDetail = true
      this.$refs.detail.setEdit(false)
      this.$refs.detail.init(row)
    },
    editDetail(row) {
      this.isShowDetail = true
      this.$refs.detail.setEdit(true)
      this.$refs.detail.init(row)
    },
    openCreate() {
      this.isShowCreateInvoice = !this.isShowCreateInvoice
      this.isImport = false;
    },
    async delEvent(row) {
      let confirm = await this.$XModal.confirm({
        title: '提示',
        message: '是否删除',
        'confirm-button-text': '确定',
        'cancel-button-text': '取消'
      })

      if (confirm == 'cancel') return

      let action = this.cate == 'Sales' ? 'removeInvoiceSeller' : 'removeInvoiceBuyer'
      let params = {
        id: row.id
      }
      let res = await $api.invoice.request(action, params)
      if (res.status == 1) {
        this.$XModal.message('删除成功')
      }
      this.getListData()
    },
    showTempModal() {
      if (this.cate == 'Sales') {
        this.$refs.modalTemplate.setExport('711销项发票信息导入模板.xls');
      } else {
        this.$refs.modalTemplate.setExport('710进项发票信息导入模板.xls');
      }
      this.templateVisible = true;
    },
    goImport() {
      this.isShowCreateInvoice = true
      this.isImport = true;
      this.templateVisible = false;
      this.title = '发票信息导入';
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    authCreate() {
      return this.cate == 'Sales' && this.isHavePermission('invoice:createInvoiceSeller') || this.cate == 'Income' && this.isHavePermission('invoice:createInvoiceBuyer')
    },
    authRemove() {
      return this.cate == 'Sales' && this.isHavePermission('invoice:removeInvoiceSeller') || this.cate == 'Income' && this.isHavePermission('invoice:removeInvoiceBuyer')
    },
    authUpdate() {
      return this.cate == 'Sales' && this.isHavePermission('invoice:updateInvoiceSeller') || this.cate == 'Income' && this.isHavePermission('invoice:updateInvoiceBuyer')
    },
    authDownload() {
      return this.cate == 'Sales' && this.isHavePermission('invoice:sales:download') || this.cate == 'Income' && this.isHavePermission('invoice:income:download')
    },
  },
};
